angular.module('callX').controller('LeadUserDetailsCtrl', ['$scope', 'LeadsService', '$stateParams', 'toaster', 'UserService', '$state', 'ngAudio', '$timeout', function($scope, LeadsService, $stateParams, toaster, UserService, $state, ngAudio, $timeout) {

    $scope.leadId = $stateParams.leadId;
    $scope.lead = {};
    $scope.allFieldsList = [];

    var setDynamicFields = function () {
        $scope.lead.dynamicFields = [];
        /*angular.forEach($scope.lead, function(value, key) {
            console.log(key + ': ' + value);
        });*/
        for(var i = 0; i<$scope.allFieldsList.length; i++){
            if($scope.lead[$scope.allFieldsList[i].form_variable]!=null&&$scope.lead[$scope.allFieldsList[i].form_variable]!=undefined){
                var fieldObj = {
                    label: $scope.allFieldsList[i].label,
                    value: $scope.lead[$scope.allFieldsList[i].form_variable]
                };
                $scope.lead.dynamicFields.push(fieldObj)
            }
        }
        $scope.loadingDetailsContent = false;
    };

    var fetchAllFieldsList = function(){
        var callbacks = {
            success: function(data) {
                $scope.allFieldsList = data.data;
                setDynamicFields();
            },
            failure: function(data) {
                $scope.loadingDetailsContent = false;
            }
        };
        LeadsService.getAllFieldsListForLeads(callbacks);
    };

    var fetchLeadData = function(){
        $scope.loadingDetailsContent = true;
        var callbacks = {
            success: function(data) {
                $scope.lead = data.data;
                fetchAllFieldsList();
            },
            failure: function(data) {
                $scope.loadingDetailsContent = false;
            }
        };
        LeadsService.getSingleLeadUserDetails($scope.leadId, callbacks);
    };



    fetchLeadData();

}]);